import Loader1 from './loader1.gif';
import Loader2 from './loader2.gif';

export const gifs = {
	Loader1,
	Loader2,
};
